<template>
    <div class="authority">
        <div class="content">
            <h2 class="title">Motivos para Cotar Conosco</h2>
            <div class="card-box">
                <div class="card">
                    <span class="material-icons-outlined material icon">verified_user</span>
                    <h3 class="title">Segurança</h3>
                </div>
                <div class="card">
                    <span class="material-icons-outlined material icon">people</span>
                    <h3 class="title">Profissionalismo</h3>
                </div>
                <div class="card mr-0">
                    <span class="material-icons-outlined material icon">speed</span>
                    <h3 class="title">Praticidade</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.authority {
    @apply py-8 md:py-8 lg:py-16;
    background-color: #edededbf;
    .content {
        @apply container mx-auto px-8;
        .title {
            @apply text-center font-bold mb-8 md:mb-16;
            font-size: 36px;
            line-height: 36px;
            color: #0f2d53;
            // tablet
            @media screen and (max-width: 1024px) {
                font-size: 28px;
                line-height: 28px;
            }
            // mobile
            @media screen and (max-width: 767px) {
                font-size: 20px;
            }
        }
        .card-box {
            @apply grid grid-cols-3;
            .card {
                // card 1
                @apply p-4 lg:py-16 lg:px-8 rounded-md md:mr-2 lg:mr-4 mb-8 col-span-3 md:col-span-1;
                background-color: white;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                // card 2
                &:nth-child(2) {
                    @apply md:mx-2 lg:mx-4;
                }
                // card 3
                &:nth-child(3) {
                    @apply md:ml-2 lg:ml-4 md:mr-0;
                }
                .icon {
                    @apply w-full text-center mb-4;
                    color: #fdc30c;
                    font-size: 100px;
                    // tablet
                    @media screen and (max-width: 1024px) {
                        &:nth-child(1) {
                            font-size: 53px !important;
                            line-height: 37px !important;
                        }
                    }
                    // mobile
                    @media screen and (max-width: 767px) {
                        font-size: 48px;
                    }
                }
                .title {
                    @apply font-bold mb-4 text-center;
                    font-size: 28px;
                    color: #0e53a5;
                    @media screen and (max-width: 1024px) {
                        font-size: 18px;
                    }
                }
            }
        }
    }
}
</style>
